import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import Card from "../components/Card/Card";
import CardHeader from "../components/CardHeader/CardHeader";
import styled from "styled-components";
import theme from "../theme/theme";
import CustomButton from "../components/CustomButton/CustomButton";
import { useHistory } from "react-router-dom";
import {
  establishSSOConnectionAction,
  resetEstablishSSOConnection,
  resetVerificationForm,
} from "../redux/actions";
import firstImg from "./../assets/1.png";
import secondImg from "./../assets/2.png";
import thirdImg from "./../assets/3.png";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { SET_LOADING } from "../redux/action-types";
import Header from "../components/Header";

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  .mainContainer {
    margin-top: 4em;
  }

  .headerMessage {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};
  }

  .title {
    color: #48c8f4;
  }

  .errorText {
    min-width: 300px;
    color: ${theme.colors.error};
  }

  .buttonContainer {
    margin: 2em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .checkIcon {
    display: flex;
    align-items: baseline;
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .imgCheck {
    margin-right: 1em;
  }

  .numberContainer {
    display: flex;
    align-items: center;
  }

  .numberImg {
    margin-right: 1em;
  }

  .helpButton {
    color: white;
    padding: 15px 40px;
    border: none;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    background-color: #48c8f4;
  }

  .buttonBackContainer {
    margin-top: 2em;
    margin-right: 2em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media (max-width: 480px) {
      margin: 0 7px 0 0;
    }
  }

  .notificationContainer {
    margin-top: 1em;
    margin-right: 2em;
    @media (max-width: 480px) {
      margin: 0 7px 0 0;
    }
  }

  @media (max-width: 480px) {
    .checkIcon {
      display: flex;
      align-items: baseline;
      flex-wrap: nowrap;
      flex-direction: column;
    }
  }
`;

const VerificationRiaForm = () => {
  const {
    verificationForm,
    loading,
    establishSSOConnection,
    setGoalToLaunchPayLoad,
    userAccountDetails,
  } = useSelector((state) => state.user);
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoaded, setIsLoaded] = useState(true);

  useEffect(() => {
    dispatch({ type: SET_LOADING, payload: true });
    setIsLoaded(false);
    if (verificationForm && userAccountDetails) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [dispatch, userAccountDetails, verificationForm]);

  const handleEditDetails = () => {
    history.push("/ria-form");
  };

  const handleHelp = () => {
    alert("help");
  };

  const handleContinue = () => {
    dispatch(establishSSOConnectionAction(setGoalToLaunchPayLoad?.goalId));
  };

  useEffect(() => {
    if (establishSSOConnection?.SIGNED_URL) {
      window.open(establishSSOConnection?.SIGNED_URL, "_blank");
      dispatch(resetEstablishSSOConnection());
      dispatch(resetVerificationForm());
      history.push("/strategy-screen");
    }
  }, [dispatch, establishSSOConnection, history]);

  return (
    <>
      {(loading || !isLoaded) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <Header />
      <BodyWrapper>
        <div className="mainContainer">
          {verificationForm?.isError === undefined ? (
            <></>
          ) : (
            <>
              {verificationForm?.isError === false ? (
                <>
                  <Card>
                    <div
                      className="headerMessage"
                      style={{ fontSize: "32px", fontWeight: 700 }}
                    >
                      {/* <FontAwesomeIcon
                        style={{ color: "#6ADD98", fontSize: "32px" }}
                        icon={faCheckCircle}
                      />{" "} */}
                      Your application is almost done!
                    </div>

                    <h2 className="title">Next Steps:</h2>
                    <div className="numberContainer">
                      <div>
                        <img
                          className="numberImg"
                          src={`${firstImg}`}
                          alt="1-icon"
                        ></img>
                      </div>
                      <p>Finish your application</p>
                    </div>
                    <div className="numberContainer">
                      <div>
                        <img
                          className="numberImg"
                          src={`${secondImg}`}
                          alt="2-icon"
                        ></img>
                      </div>
                      <p>Fund your account</p>
                    </div>
                    <div className="numberContainer">
                      <div>
                        <img
                          className="numberImg"
                          src={`${thirdImg}`}
                          alt="3-icon"
                        ></img>
                      </div>
                      <p>Manage your investment</p>
                    </div>
                  </Card>
                  <div className="buttonBackContainer">
                    <div>{""}</div>
                    <CustomButton
                      text="Finish Application"
                      nextLogo
                      onClick={handleContinue}
                    />
                  </div>
                  <div className="notificationContainer">
                    <div style={{ float: "right" }}>
                      *This will launch a new window
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Card>
                    <CardHeader text={"Oops!"} />
                    <p className="errorText">
                      {verificationForm?.errorMessage}
                    </p>
                  </Card>
                  <div className="buttonContainer">
                    <button className="helpButton" onClick={handleHelp}>
                      HELP
                    </button>
                    <CustomButton
                      text="EDIT DETAILS"
                      nextLogo
                      onClick={handleEditDetails}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </BodyWrapper>
    </>
  );
};

export default VerificationRiaForm;
